import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles'
import { Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Toolbar, Typography  } from '@material-ui/core';

import { Link as RouterLink, useHistory } from 'react-router-dom'

import { useSelector } from 'react-redux';

import { Properties } from '../constants/config'
import { Property } from '../constants/property'

const useStyles = makeStyles((theme) => ({
    head: {
        backgroundColor: '#3f51b5',
        color: '#fff'
    },
    listWrap: {
        marginTop: '10px'
    }
}));

function PropertyListDialog(props) {
    const { open, onClose } = props;

    const states = useSelector(state => state);

    const classes = useStyles();

    return(
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>入力した財産一覧</DialogTitle>
            <DialogContent>
                    {
                        (() => {
                            return Object.keys(Property).map((propertyData, index) => {
                                let propertyList = Property[propertyData];

                                let state = states[propertyData.toLowerCase()][propertyData.toLowerCase()];
                                if(state !== undefined && state.length){
                                   return (
                                        <Paper className={classes.listWrap} component={RouterLink} to={() => { return '/'+propertyData; }}>
                                            <Toolbar>
                                                <Typography variant="h6">{Properties[propertyData]}</Typography>
                                            </Toolbar>
                                            <TableContainer component={Paper}>
                                                <Table size="small">
                                                    {
                                                        state.map((row, rowIndex) => {
                                                            return (
                                                                <>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell className={classes.head} colspan={2}>財産番号&nbsp;({rowIndex+1})</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>

                                                                    <TableBody>
                                                                        {
                                                                            Object.keys(propertyList).map((cell, cellName) => {
                                                                                return (

                                                                                    <TableRow hover>
                                                                                        <TableCell>{propertyList[cell]}</TableCell>
                                                                                        <TableCell>{row[cell]}</TableCell>
                                                                                    </TableRow>
                                                                                );
                                                                            })
                                                                        }
                                                                    </TableBody>
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </Table>
                                            </TableContainer>
                                        </Paper>
                                   );
                                }else{
                                }
                            })
                        })()
                    }
            </DialogContent>
        </Dialog>
    );
}

export default PropertyListDialog;
